import { getApigeeUrl, getEnv } from '@adsk/acs-sc-web-platform-api';
import { RFI_PATHS } from './constants';

export const getApiBaseUrl = (projectId: string) => {
  // Local development override: when set, route RFI API calls to a locally
  // running Core service instead of Apigee. Defaults to undefined in normal
  // builds, so production/QA behavior is unchanged. Set via .env.local or the
  // `rfis-local` CLI (see packages/rfis-local-cli/README.md in rfis-service).
  //
  // Intentional design decision: this dev-only escape hatch lives in the
  // published `@adsk/acc-rfis` lib. That is acceptable because the RFI team
  // owns every consumer of this package, and the var name is specific enough
  // that an accidental collision in a consumer's environment is improbable. If
  // this lib is ever consumed outside the team, revisit (namespace the var or
  // move the override to the app layer).
  //
  // `typeof process` guard: in the acs-rfis app build this is substituted by
  // rsbuild's source.define, but the published lib could be consumed by a host
  // whose bundler neither defines this var nor shims `process` — the guard
  // prevents a ReferenceError there (it just resolves to undefined → Apigee).
  const localApiBaseUrl =
    typeof process !== 'undefined' ? process.env.PUBLIC_LOCAL_RFIS_API_URL : undefined;
  if (localApiBaseUrl) {
    return `${localApiBaseUrl}/projects/${projectId}`;
  }

  const env = getEnv();
  const apigeeUrl = getApigeeUrl();
  const RFIsPath = RFI_PATHS[env];
  const apiBaseUrl = `${apigeeUrl}${RFIsPath}/projects/${projectId}`;
  return apiBaseUrl;
};
